module.exports = __webpack_public_path__ + "static/media/alfabank.feb5da25.png";